import { render } from "./home-page.vue?vue&type=template&id=7a721fa2&scoped=true"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"

import "./home-page.vue?vue&type=style&index=0&id=7a721fa2&scoped=true&lang=css"

import exportComponent from "C:\\trabajo_espacio\\cuadros.ges.com\\com.ges.cuadros\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a721fa2"]])

export default __exports__